"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFetchAdvancedTrackingCodeRequestStatus = exports.getFetchBasicTrackingCodeRequestStatus = exports.getSaveStagedChangesRequestStatus = exports.getFetchIPRequestStatus = exports.getFetchViewsRequestStatus = exports.getFetchSubdomainsRequestStatus = exports.getFetchDomainsRequestStatus = exports.getFetchSettingsRequestStatus = exports.getSendTrackingCodeRequestStatus = void 0;

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var _TrackingCodeActions = require("../actions/TrackingCodeActions");

var _SettingsActions = require("../actions/SettingsActions");

var _DomainsActions = require("../actions/DomainsActions");

var _StagingActions = require("../actions/StagingActions");

var _SubdomainsActions = require("../actions/SubdomainsActions");

var _AnalyticsViewsActions = require("../actions/AnalyticsViewsActions");

var getSendTrackingCodeRequestStatus = (0, _getRequestStatus.default)(_TrackingCodeActions.TrackingCodeActionTypes.SEND_TRACKING_CODE);
exports.getSendTrackingCodeRequestStatus = getSendTrackingCodeRequestStatus;
var getFetchSettingsRequestStatus = (0, _getRequestStatus.default)(_SettingsActions.SettingsActionTypes.FETCH_SETTINGS);
exports.getFetchSettingsRequestStatus = getFetchSettingsRequestStatus;
var getFetchDomainsRequestStatus = (0, _getRequestStatus.default)(_DomainsActions.DomainsActionTypes.FETCH_DOMAINS);
exports.getFetchDomainsRequestStatus = getFetchDomainsRequestStatus;
var getFetchSubdomainsRequestStatus = (0, _getRequestStatus.default)(_SubdomainsActions.SubdomainsActionTypes.FETCH_SUBDOMAINS);
exports.getFetchSubdomainsRequestStatus = getFetchSubdomainsRequestStatus;
var getFetchViewsRequestStatus = (0, _getRequestStatus.default)(_AnalyticsViewsActions.AnalyticsViewsActionTypes.FETCH_VIEWS);
exports.getFetchViewsRequestStatus = getFetchViewsRequestStatus;
var getFetchIPRequestStatus = (0, _getRequestStatus.default)(_SettingsActions.SettingsActionTypes.FETCH_IP);
exports.getFetchIPRequestStatus = getFetchIPRequestStatus;
var getSaveStagedChangesRequestStatus = (0, _getRequestStatus.default)(_StagingActions.StagingActionTypes.SAVE_STAGED_CHANGES);
exports.getSaveStagedChangesRequestStatus = getSaveStagedChangesRequestStatus;
var getFetchBasicTrackingCodeRequestStatus = (0, _getRequestStatus.default)(_TrackingCodeActions.TrackingCodeActionTypes.FETCH_BASIC_TRACKING_CODE);
exports.getFetchBasicTrackingCodeRequestStatus = getFetchBasicTrackingCodeRequestStatus;
var getFetchAdvancedTrackingCodeRequestStatus = (0, _getRequestStatus.default)(_TrackingCodeActions.TrackingCodeActionTypes.FETCH_ADVANCED_TRACKING_CODE);
exports.getFetchAdvancedTrackingCodeRequestStatus = getFetchAdvancedTrackingCodeRequestStatus;